import apiSlice from "./ApiSlice";

export const assetsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // ADD
    addAssets: builder.mutation({
      invalidatesTags: ["asset"],
      query: (body) => {
        return {
          url: "/asset/add",
          method: "POST",
          body,
        };
      },
    }),
    // GET
    getAllAssets: builder.query({
      providesTags: ["asset"],
      query: (body) => {
        return {
          url: "/asset",
          method: "POST",
          body,
        };
      },
    }),
    // EDIT
    editAssets: builder.mutation({
      invalidatesTags: ["asset"],
      query: ({ body, id }: any) => {
        return {
          url: `/asset/${id}`,
          method: "PUT",
          body,
        };
      },
    }),

    //Single View
    getAssetsById: builder.query({
      providesTags: ["asset"],
      query: (id: any) => {
        return {
          url: `/asset/${id}`,
          method: "GET",
        };
      },
    }),

    // DELETE
    deleteAssets: builder.mutation({
      invalidatesTags: ["asset"],
      query: ({ id }) => {
        return {
          url: `/asset/${id}`,
          method: "DELETE",
        };
      },
    }),
  }),
});

export const {
  useAddAssetsMutation,
  useGetAllAssetsQuery,
  useDeleteAssetsMutation,
  useEditAssetsMutation,
  useGetAssetsByIdQuery,
} = assetsApi;
